// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"3ac0452f","338":"13cb35b7","406":"3af22800","502":"c4d67a66","530":"b919d92a"}[chunkId] + ".chunk.js";
};